module.exports = "https://r.nearpod.com/assets/media/image/enlarge-icon-051a5e1d78302c36888ae7fd35462972.svg";